import Router from 'vue-router'
import Vue from 'vue'

const routes = [
  {
    name: 'Home',
    path: "/pingancx",
    component: () => import('@/views/Home')
  },{
    name: 'Competition',
    path: "/pingancx/competition/:type",
    component: () => import('@/views/Competition')
  },{
    name: 'Limited',
    path: "/pingancx/limited/:type",
    component: () => import('@/views/Limited')
  },{
    name: 'Promotion',
    path: "/pingancx/promotion/:type",
    component: () => import('@/views/Promotion')
  },{
    name: 'Question',
    path: "/pingancx/question",
    component: () => import('@/views/Question')
  },{
    name: 'News',
    path: "/pingancx/news",
    component: () => import('@/views/News')
  },{
    name: 'Debug',
    path: "/pingancx/debug",
    component: () => import('@/views/Debug')
  },{
    path: "*",
    redirect: "/pingancx"
  }
]

const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
	return originalPush.call(this, location).catch(err => err)
}

const originalReplace = Router.prototype.replace
Router.prototype.replace = function replace(location) {
	return originalReplace.call(this, location).catch(err => err)
}


const router = new Router({
  // mode: 'hash',
  base: '/pingancx',
  scrollBehavior (a, b) {
    if (a.name !== b.name)
      return { x: 0, y: 0 }
  },
  routes
})

Vue.use(Router)

export default router